/* eslint camelcase: "off" */
import React from "react"
import PropTypes from "prop-types"
import {
  FormContainer,
  InputField,
  StandardModal,
  CheckboxYesNo,
  LabeledInput
} from "uikit"
import { Grid, Form } from "semantic-ui-react"
import { propertySchema } from "components/properties/propertySchema"

const RealEstateForm = ({
  data: {
    fields: { description, value, property_taxes, is_primary_residence },
    isModified,
    onSubmit,
    isPending,
    hasError,
    error
  },
  submitLabel = "Add Real Estate",
  submitHeader = "",
  onCancel,
  askIfPrimaryResidence
}) => (
  <Form
    error={hasError}
    loading={isPending}
    className="AddModal__Form"
    onSubmit={onSubmit}
  >
    <Grid>
      <Grid.Row>
        <Grid.Column>
          <InputField
            autoFocus
            field={description}
            label="Property Name"
            className="AddModal__FormField"
            data-testid="description"
          />
          <InputField
            field={value}
            label="Current Market value"
            className="AddModal__FormField LabeledInput"
            control={LabeledInput}
            iconText="$"
            iconPosition="left"
            placeholder="Current Market value"
            textPosition="left"
            data-testid="value"
          />

          <InputField
            field={property_taxes}
            label="Annual property taxes"
            className="AddModal__FormField LabeledInput"
            control={LabeledInput}
            iconText="$"
            iconPosition="left"
            textPosition="left"
            data-testid="property_taxes"
          />
          <InputField
            field={is_primary_residence}
            label="Primary residence?"
            className="AddModal__FormField"
            fluid
            control={CheckboxYesNo}
            data-testid="is_primary_residence"
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
    <button type="submit" style={{ display: "none" }} />
  </Form>
)

const AddRealEstateFormModal = props => (
  <StandardModal defaultOpen={true} closeOnDimmerClick={false}>
    <StandardModal.Header header="Add Real Estate" />
    <StandardModal.Content>
      <RealEstateForm {...props} />
    </StandardModal.Content>
    <StandardModal.Actions
      submitLabel="Add Real Estate"
      cancelLabel="Cancel"
      onSubmit={props.data.onSubmit}
      onCancel={props.onCancel}
      loading={props.data.isPending}
      submitDataAttr={{ "data-testid": "addProperty" }}
    />
  </StandardModal>
)

export const AddRealEstateModal = FormContainer(propertySchema)(
  AddRealEstateFormModal
)

AddRealEstateModal.PropTypes = {
  submit: PropTypes.func,
  onCancel: PropTypes.func
}
